'use strict';
import {shopModule} from '../module.js';
import {ErrorMessageList} from '@nuskin/ns-shop';

shopModule.factory('nsSection',function() {
    let nsSection = function () {
        this.error = new ErrorMessageList();
        this.edit = false;
        this.pristine = true;
        this.selecting = false;
        this.editing = false;
        this.adding = false;
        this.newFormUrl = '';
        this.editFormUrl = '';

        this.isSelected = function() {
            return !(this.adding || this.editing || this.selecting);
        }
    };

    return nsSection;
});
